<template>
  <Toast position="top-right" class="fixed-top" style="z-index: 9999" />

  <div class="relative min-h-screen">
    
    <Transition name="fade-loading">
      <div 
        v-if="context.isLoadingApplication" 
        class="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-void text-white"
      >
        <div class="w-12 h-12 border-4 border-third-color border-t-transparent rounded-full animate-spin"></div>
        <p class="mt-4 text-sm font-medium tracking-wide text-gray-400 animate-pulse">
          Carregando soluções...
        </p>
      </div>
    </Transition>

    <main :class="{ 'opacity-0 h-screen overflow-hidden': context.isLoadingApplication }" class="transition-opacity duration-300">
      <RouterView />
    </main>

  </div>
</template>

<script setup>
import { onMounted } from "vue";
import Toast from "primevue/toast";
import { RouterView } from "vue-router";
import { useContextStore } from "@/stores/context";

const context = useContextStore();

onMounted(() => {
  setTimeout(() => {
    context.setLoadingApplication(false);
  }, 100); 
});
</script>

<style scoped>
.fade-loading-enter-active,
.fade-loading-leave-active {
  transition: opacity 0.4s ease-in-out;
}

.fade-loading-enter-from,
.fade-loading-leave-to {
  opacity: 0;
}
</style>